export { DBConnectionComponentService } from './db-connection-component.service';
export { DialogManagerService } from './dialog-manager.service';
export { SessionService } from './session.service';
export { WidgetsHelper } from './widgets-helper.service';
export { AuthService } from './auth.service'
export {TranformtionImpactServerClientFilterObjectService} from './trans-impact-server-client'



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/index.ts